import { i18n } from "@dehub/theme";

type DateInput = string | number | Date | null | undefined;

const formatters = new Map<string, Intl.DateTimeFormat>();

function formatterFor(withTime: boolean) {
  // Latin digits whatever the UI language, so the date always reads YYYY-MM-DD.
  const locale = `${i18n.language || "mn"}-u-nu-latn`;
  const key = `${locale}|${withTime}`;
  let formatter = formatters.get(key);
  if (!formatter) {
    try {
      formatter = new Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        ...(withTime ? { hour: "2-digit", minute: "2-digit", hourCycle: "h23" as const } : {}),
      });
    } catch {
      formatter = new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "2-digit", day: "2-digit" });
    }
    formatters.set(key, formatter);
  }
  return formatter;
}

function format(value: DateInput, withTime: boolean): string {
  if (value === null || value === undefined || value === "") return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  // Assembled from parts: the order of year/month/day is the locale's, the output is not.
  const part = (type: string) => formatterFor(withTime).formatToParts(date).find((p) => p.type === type)?.value ?? "";
  const day = `${part("year")}-${part("month")}-${part("day")}`;
  return withTime ? `${day} ${part("hour")}:${part("minute")}` : day;
}

/** YYYY-MM-DD in the viewer's time zone. Empty string when there is no valid date. */
export const formatDate = (value: DateInput): string => format(value, false);

/** YYYY-MM-DD HH:mm (24 hour). Empty string when there is no valid date. */
export const formatDateTime = (value: DateInput): string => format(value, true);
